var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWomanArmBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "119px",
    height: "50px",
    viewBox: "0 0 119 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "WomanArmBack") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WomanArmBack",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M110.232576,42.2627377 C123.374778,39.1728228 117.845437,27.7714467 117.845437,27.7714467 L102.790002,14.1774214 C93.9751103,13.8123133 76.4755464,23.1440765 61.0394687,30.1831609 C56.6019719,30.8813676 52.1845091,29.8520628 48.6685692,27.3053087 L19.2789182,6 L14,11.7907147 L37.1090405,41.1284018 C45.3629847,52.7038294 64.9360516,49.7099429 68.2516529,49.500881 C68.2516529,49.500881 94.5861425,45.937826 110.232576,42.2627377",
    id: "Fill-139",
    fill: "#FF9B3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1998522,36.5957586 C93.1998522,36.5957586 56.1658663,48.5305633 46.1019579,40.9315271 C36.0280754,33.3324909 18.194311,11 18.194311,11 L16,14.6283955 L36.9357222,41.1762722 C45.1544145,52.6892398 64.6438862,49.711508 67.9453269,49.5035742 C67.9453269,49.5035742 102.482343,43.5023453 116.535908,40.9315271 L116.535908,30.5",
    id: "Fill-140",
    fill: "#F2933A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.804981378,3.61435518 L0.804981378,3.61435518 C-0.899859606,7.53051194 0.193997904,11.8644056 3.22920613,13.243649 L15.7740765,15.460399 C18.8191393,16.8416752 16.8186611,15.5711857 18.5235021,11.6479142 C20.2184885,7.73074108 23.3325333,8.55300187 18.0997555,4.59110749 L9.41787745,0.897540481 C8.29445622,0.416787263 7.09219842,0.0884927829 5.87023147,0.0163289806 C3.5938253,-0.117834708 2.14520319,0.53062312 0.804981378,3.61435518",
    id: "Fill-149",
    fill: "#ED5353"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomanArmBack);
export default __webpack_public_path__ + "static/media/WomanArmBack.ad0bfe1c13f2ce617bb08e4032724587.svg";
export { ForwardRef as ReactComponent };